// @flow
import React from "react";
import { put, call, all, takeEvery } from "redux-saga/effects";
import { SubmissionError } from "redux-form";
import type { Saga, Effect } from "redux-saga";
import MapAPI from "../api/MapAPI";
import {
    EVENT_CREATE_REQUESTED,
    EVENT_CREATE_LOADING,
    EVENT_CREATE_SUCCESS,
} from "../actions/constants";

type Props = {
    payload: Object,
    type: Object,
};

export function* submitForm(promise: Props): Saga<void> {
    const {
        payload: { values, reject },
    } = promise;

    yield put({ type: EVENT_CREATE_LOADING, payload: true });

    try {
        const parsedValues = { ...values };

        if (parsedValues.additionalKit) {
            parsedValues.additionalKit = parseInt(
                parsedValues.additionalKit,
                10
            );
        }

        if (parsedValues.ownerFirstParticipation) {
            parsedValues.ownerFirstParticipation = parseInt(
                parsedValues.ownerFirstParticipation,
                10
            );
        }

        const { medias, ...dataEvent } = parsedValues;

        const datesOrder = ["Vendredi 23", "Samedi 24", "Dimanche 25"];
        if (dataEvent.dateEvent) {
            const dates = dataEvent.dateEvent;
            dates.sort((a, b) => datesOrder.indexOf(a) - datesOrder.indexOf(b));

            switch (dates.length) {
                case 1:
                    // eslint-disable-next-line prefer-destructuring
                    dataEvent.dateEvent = dates[0];
                    break;
                case 2:
                    dataEvent.dateEvent = `${dates[0]} et ${dates[1]}`;
                    break;
                case 3:
                    dataEvent.dateEvent = `${dates[0]}, ${dates[1]} et ${dates[2]}`;
                    break;
                default:
                    dataEvent.dateEvent = "";
            }

            dataEvent.dateEvent += " Juin 2025";
        }

        const response = yield call(MapAPI.postEvent, dataEvent);

        if (
            response.status === 201 &&
            response.data &&
            response.data.id &&
            medias &&
            medias.length > 0
        ) {
            const formDataArray = [];
            /* eslint-disable */
            for (let i = 0; i < medias.length; i++) {
                const formData = new FormData();
                formData.append("file", medias[i].file, medias[i].file.name);
                formData.append("event", response.data.id);

                formDataArray[i] = call(MapAPI.postMedias, formData);
            }
            /* eslint-enable */

            yield all(formDataArray);
        }

        yield put({ type: EVENT_CREATE_LOADING, payload: false });
        yield put({
            type: EVENT_CREATE_SUCCESS,
            payload: (
                <>
                    <p>Formulaire enregistré avec succès, merci.</p>
                    <p>Vous allez recevoir un mail de confirmation.</p>
                </>
            ),
        });
    } catch (error) {
        const list = error.response.data.violations.map(item => {
            const obj = {};
            obj[item.propertyPath] = item.message;
            if (item.propertyPath === "file") obj.medias = item.message;
            return obj;
        });
        const obj = list.reduce((o, key) => ({ ...o, ...key }), {});
        obj._error =
            "Impossible de soumettre le formulaire, merci de vérifier les informations saisies.";

        yield call(reject, new SubmissionError(obj));
        yield put({ type: EVENT_CREATE_LOADING, payload: false });
    }
}

export function* watchSubmitForm(): Iterable<Effect> {
    yield takeEvery(EVENT_CREATE_REQUESTED, submitForm);
}

export default function* root(): Iterable<Effect> {
    // $FlowFixMe
    yield all([watchSubmitForm()]);
}
